import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { Button, Modal,  Select } from "antd";
import { useFormik } from 'formik';
import * as yup from "yup";
import ExpandableMyTask from "../Components/ExpandableMyTask";
import TaskLayout from "../TaskLayout";
import axiosInstance from "../../../../Services/axiosCommon";
import { GetAccess, GetRole } from "../../../../Components/Utils/roles";
import MobileTask from "../../../Mobile/Task/MobileMyTask";
import Pagination from "../../../../Components/Utils/Pagenation";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import { NuDate } from "../../../../Components/Utils/Input";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import SearchBar from "../../../../Components/Utils/SearchBar";
import { CancelButton, FilterButton, SubmitButton } from "../../../../Components/Utils/Buttons";
import { useToast } from "../../../../Components/Others/ToastServices";
import UseGetDataSearchByPro from "../../../../Components/Hooks/useFetchDataByPRO";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
// let dummyData = [
//   {
//     id: 1,
//     name: "Design Homepage",
//     assignTo: "John Doe",
//     copyTo: "Jane Smith",
//     startDate: "2024-03-25",
//     endDate: "2024-03-30",
//     noOfDays: 5,
//     completion: "50",
//     priority: "High",
//     status: "In Progress",
//     action: "Edit",
//   },
//   {
//     id: 2,
//     name: "API Development",
//     assignTo: "Michael Brown",
//     copyTo: "Sarah Johnson",
//     startDate: "2024-03-20",
//     endDate: "2024-03-28",
//     noOfDays: 8,
//     completion: "70",
//     priority: "Medium",
//     status: "In Progress",
//     action: "Edit",
//   },
//   {
//     id: 3,
//     name: "Testing & Debugging",
//     assignTo: "Alice Williams",
//     copyTo: "Robert Wilson",
//     startDate: "2024-03-22",
//     endDate: "2024-03-27",
//     noOfDays: 5,
//     completion: "30",
//     priority: "Low",
//     status: "Pending",
//     action: "Edit",
//   },
//   {
//     id: 4,
//     name: "Deployment",
//     assignTo: "Emma Davis",
//     copyTo: "David Miller",
//     startDate: "2024-03-29",
//     endDate: "2024-04-02",
//     noOfDays: 4,
//     completion: "10",
//     priority: "High",
//     status: "Not Started",
//     action: "Edit",
//   },
// ];





function MyTask() {
  const { value: taskpriority } = useFetchMataData(
     `/dropdown/dropdown-details/`,
     "taskpriority"
   );
   const { value: taskstatus } = useFetchMataData(
     `/dropdown/dropdown-details/`,
     "taskstatus"
   );
  const location = useLocation();
   const [pageIndex, setPageIndex] = useState(1);
  const [dataCount, setDataCount] = useState(20);
  const [totalTasks, setTotalProject] = useState(0);
  // const [searchQuery, setSearchQuery] = useState("");
   const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });
  const toast = useToast();
  const state = location.state;

       const currentPage= location.state?.currentPage
    const searchQuery= location.state?.searchQuery

    const [page, setPage] = useState(currentPage||1)
    const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
    const [filter, setFilter] = useState(false);
    const [showFilterDialog, setShowFilterDialog] = useState(false);
  
  const [filterProps, setFilterProps] = useState({
 
    priority:'',
    taskStatus:'',
    startDateFrom:'',
    startDateTo:'',
    endDateFrom:'',
    endDateTo:'',
    completeDateFrom:'',
    completeDateTo:'',
  });
  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search:searchQuery||"",
    priority:'',
    taskStatus:'',
    startDateFrom:'',
    startDateTo:'',
    endDateFrom:'',
    endDateTo:'',
    completeDateFrom:'',
    completeDateTo:'',
  });
  const clearFilter = ()=> {
    setParams({...params,   priority:'',
      taskStatus:'',
      startDateFrom:'',
      startDateTo:'',
      endDateFrom:'',
      endDateTo:'',
      completeDateFrom:'',
      completeDateTo:'',
  })
  formik.values.startDateFrom=""
  formik.values.startDateTo=""
  formik.values.taskStatus=""
  formik.values.priority=""
  formik.values.endDateFrom=""
  formik.values.endDateTo=""
  formik.values.completeDateFrom=""
  formik.values.completeDateTo=""




      setFilter(false)
  }

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff",value);
      setParams({...params,startDateTo:value.startDateTo,completeDateTo:value.completeDateTo,completeDateFrom:value.completeDateFrom,endDateTo:value.endDateTo,endDateFrom:value.endDateFrom, taskStatus:value.taskStatus,priority:value.priority,startDateFrom:value.startDateFrom})
      closeFilterDialog();
      setFilter(true)
      setFilterProps({
        priority:'',
    taskStatus:'',
    startDateFrom:'',
    startDateTo:'',
    endDateFrom:'',
    endDateTo:'',
    completeDateFrom:'',
    completeDateTo:'',
      });
    }
  })

  const { data, totalCount, getData,dataLoading } = UseGetDataSearchByPro( '/tasks/member-all-tasks',params);
  
useEffect(()=>{
    setParams({...params,page:page,per_page:pageCount})
   },[page,pageCount])

    const closeFilterDialog = () => {
      setShowFilterDialog(false);
    };


  return (
  <>
  <div className='w-full h-full px-4 py-2'>
      <div className='w-full flex justify-between items-center'>
        <Breadcrumb
          items={[
            { name: " Task" },

            // {
            //   // name: "Items",
            //   // link: "/products/items"
            // },

          ]} />
        <div className=' flex gap-2'>
        <SearchBar
              handleChange={(e) =>{
                setParams({ ...params, search: e.target.value, page:1 });
                setPage(1)
              }}
              value={params.search||searchQuery}
            /> <FilterButton  handleClick={()=>setShowFilterDialog(true)} />
          {filter && <FilterButton  handleClick={()=>clearFilter()} label='Clear'/>}
        
          {/* {GetRole() && <ImportButton handleClick={handleImportClick} />}
          {GetAccess("items_create") &&<Link to="/products/items/create"><CreateButton label='Product' /></Link>} */}
        </div>
      </div>
   {screenSize.width<="786"?<MobileTask Data={data} getData={getData}  />:
    <div className=" w-full h-[calc(100vh-145px)] bg-white rounded-md overflow-hidden mt-4">
      <div className="h-[calc(100vh-180px)] overflow-y-auto">
      <p className="text-[12px] 2xl:text-sm font-medium text-[#4F4768] p-2">Task {data.length > 0 && `: ${totalTasks}`}</p>

    <table
      className="table-auto w-full"
      style={{ border: "none", borderCollapse: "collapse" }}
    >
      <thead className=" w-full bg-white p-3 mt-4">
        <tr className="text-xs border-b  font-medium  py-3">
          {header.map((header, i) => (
            <th
              className={`py-3 ${header.width} ${header?.isLeft?"text-left":"text-center"} font-medium text-xs 2xl:text-sm text-[#4F4768]`}
              key={i}
              style={{ border: "none", borderCollapse: "collapse" }}
            >
              {header.headone}
            </th>
          ))}
        </tr>
      </thead> 
      <tbody className="">
        {data.map((item, i) => (
          <ExpandableMyTask  item={item} key={i} getData={getData}  />
        ))}
      </tbody>
    </table>
    </div>
<div className=" h-6 my-2">
<Pagination
  total={totalTasks}
  pageIndex={pageIndex}
  setPageIndex={setPageIndex}
  dataCount={dataCount}
  setDataCount={setDataCount}
/>
</div>

</div>
}
{showFilterDialog && (
             
             
             <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
             <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
             <h2 className="text-xl mb-4">Filter  Task</h2>
                 <form onSubmit={formik.handleSubmit}>
                     <div className="flex flex-col mb-4">
                                      <p className="py-2 px-6 text-xs">Start Date</p>
                                      <div className="flex justify-between  w-full ">
                                      <NuDate
              label="Start Date From"
              // Options={status}
              formik={formik}
              placeholder="Choose"
              name="startDateFrom"
              width=" w-full"
            />
            <NuDate
              label="Start Date To"
              // Options={status}
              formik={formik}
              placeholder="Choose"
              name="startDateTo"
              width=" w-full"
            />
                              </div> 
                              <p className="py-2 px-6 text-xs">End Date</p>
                                      <div className="flex justify-between  w-full ">
                                      <NuDate
              label="End Date From"
              // Options={status}
              formik={formik}
              placeholder="Choose"
              name="endDateFrom"
              width=" w-full"
            />
            <NuDate
              label="End Date To"
              // Options={status}
              formik={formik}
              placeholder="Choose"
              name="endDateTo"
              width=" w-full"
            />
                              </div> 
                              <p className="py-2 px-6 text-xs">Completed Date</p>
                                      <div className="flex justify-between  w-full ">
                                      <NuDate
              label="Completed From"
              // Options={status}
              formik={formik}
              placeholder="Choose"
              name="completeDateFrom"
              width=" w-full"
            />
            <NuDate
              label="Completed To"
              // Options={status}
              formik={formik}
              placeholder="Choose"
              name="completeDateTo"
              width=" w-full"
            />
                              </div> 
                              <FormikSelectTwo
                              label="Priority"
                              Options={taskpriority}
                              formik={formik}
                              placeholder="Choose"
                              name="priority"
                              width=" w-full "
                            />
                                <FormikSelectTwo
                                               label="Task Status"
                                               Options={taskstatus}
                                               formik={formik}
                                               placeholder="Choose"
                                               name="taskStatus"
                                               width=" w-full "
                                             />
               
                          
         
                    </div>
                   <div className="flex justify-end gap-2">
                     <CancelButton handleClick={closeFilterDialog} />
                     <SubmitButton name='Apply' />
                   </div>
                  </form> 
               </div>
             </div>
           )}

   
      </div>
    </>
  );
}

export default MyTask;

const header = [
  {
    headone: "",
    width: "w-[3%]",
    // isLeft: true,
  }, 
  {
    headone: "Activity",
    width: "w-[31%]",
    isLeft: true,
  },
  {
    headone: "Start Date",
    width: "w-[13%]",
  },
  {
    headone: "Due Date",
    width: "w-[13%]",
  },
  {
    headone: "Duration",
    width: "w-[10%]",
  },
  {
    headone: "Priority",
    width: "w-[10%]",
  },
  {
    headone: "Status",
    width: "w-[10%]",
  },
  {
    headone: "Progress ",
    width: "w-[10%]",
  },
  {
    headone: "Action",
    width: "w-[5%]",
    isLeft: true,
  },
];
